import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchconfigurations,changeNCNPStatus,submitConfigurationAction } from '../actions/index';
import FontAwesome from 'react-fontawesome';
import * as apiConstants from '../../../constants/const';
import AdminCommonSection from '../components/adminLayout';
import {Filters, Pagination, constants, KeolisSpinner} from './common/commonExport';
import './Configurations.scss';

class Configurations extends Component {

    constructor(props){
        super(props);
        this.state = {
            showTextBox: this.props.ncnpstatus === '1'
        }
    }

    getDataForComponent(){
        let self = this,
        authDetails = this.props.authDetails,
        role = authDetails.role;
        if(role == constants.roles.ADMIN_ROLE){
            let fetchObj = {
                url:constants.actionUrls.GET_CONFIGURATIONS
            }
            this.props.fetchconfigurations(fetchObj, function(response){ // get certified emp workdays
                self.setState({
                    showTextBox: response[0].PropertyValue === "1",
                })
            });
            localStorage.setItem('route', constants.CONFIGURATIONS);
        }
    }

    formSubmit(){
        let confObj = {
            ncnpstatus:this.props.ncnpstatus,
            ncnpDays:this.props.ncnpDays
        }
        this.props.submitConfigurationAction(confObj,(response) => {});
    }

    componentWillMount(){
        localStorage.setItem('route', constants.CONFIGURATIONS);
    }
    componentDidMount(){
        this.getDataForComponent();
    }

    handleChange(value) {
        this.props.changeNCNPStatus(value, this.props.ncnpDays);
        this.setState({showTextBox: value == "1" ? true : false})
    }

    handleDayTextChange(value) {  
        if(parseInt(value) >= 0 && parseInt(value) <= 999){
            this.props.changeNCNPStatus(this.props.ncnpstatus,value);
        }   
    }

    render(){
        var route = localStorage.getItem('route') ? localStorage.getItem('route') : '',
        compTitle = constants.getComponentTitle(route);  
        // let ncnpConf = this.props.configurations.filter((item) => { return item.PropertyName == 'isNCNPActive' })[0];
        let isactiveActive = this.props.ncnpstatus;//ncnpConf ? ncnpConf.PropertyValue : '0';
        return (
            <div>
                <AdminCommonSection admin={true} compTitle={compTitle}
                    tblBody={
                        <div>
                        <div className='conf-parent' >
                            <form onSubmit={() => this.formSubmit()} className='border-class'>
                                <div className = 'form-group'>
                                    <label className='form-label'>Do you want to activate No Cert No Pay Service ?</label>
                                    <div className="combo-select">
                                    <div className="radio">
                                        <label>
                                            <input type="radio" value="1" checked={isactiveActive === '1'} onChange={(e) => this.handleChange(e.currentTarget.value)} />
                                            Yes
                                        </label>
                                        {this.state.showTextBox &&
                                        <div style={{paddingTop: 5, paddingBottom: 3}}>
                                            <label className='form-label'>Enter Days : </label>
                                            <input style={{marginLeft:20}} value={this.props.ncnpDays} type = "number" maxLength = "3" 
                                                onChange={(value)=> this.handleDayTextChange(value.target.value)}/>
                                        </div>}
                                    </div>
                                    <div className="radio">
                                        <label>
                                            <input type="radio" value="0" checked={isactiveActive === '0'} onChange={(e) => this.handleChange(e.currentTarget.value)} />
                                            No
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-default">Save</button>
                            </form>
                        </div>                      
                       </div>
                    } 
                />
                
            </div> 
        );
    }
}
function mapStateToProps(state) {
    return {
      ncnpstatus : state.configurations.ncnpstatus,
      ncnpDays : state.configurations.ncnpDays,
      authDetails:state.authState,
    };
  }
  
  function matchDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        fetchconfigurations,
        changeNCNPStatus,
        submitConfigurationAction
      },
      dispatch
    );
  }
  
  export default connect(mapStateToProps, matchDispatchToProps)(
    Configurations
  );